export const ADVANCED_FILTERS = 'ADVANCED_FILTERS';
export const VIEW_AS_COHORT = 'VIEW_AS_COHORT';
